import styled from "styled-components";
import { Title } from "../Title/Title";

export const ChangePasswordWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Content = styled.div`
  //max-width: 560px;
  border-radius: 16px;
  background-color: #FFF;
  padding: 40px;
`

export const FormTitle = styled(Title)`
    padding-bottom: 40px;
`
